import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";

export default function CTA() {
  return (
    <section data-testid="cta-section" className="relative py-32 md:py-40 border-t border-[#0E1B2E]/10 bg-[#0A1626] text-white">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 grid grid-cols-12 gap-8 items-end">
        <div className="col-span-12 md:col-span-8">
          <div className="flex items-center gap-3 text-[#C8A97E] mb-6">
            <div className="hairline w-12"></div>
            <span className="font-mono text-[11px] uppercase tracking-[0.35em]">Begin the conversation</span>
          </div>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
            className="font-serif font-light tracking-[-0.02em] text-white text-[42px] md:text-[80px] lg:text-[100px] leading-[0.98]"
          >
            Ready to make better <span className="italic text-[#C8A97E]">aviation decisions?</span>
          </motion.h2>
        </div>
        <div className="col-span-12 md:col-span-4 md:justify-self-end flex flex-col gap-4">
          <Link
            to="/contact"
            data-testid="cta-schedule"
            className="btn-gold px-8 py-5 text-[12px] uppercase tracking-[0.25em] font-mono inline-flex items-center justify-between gap-6 min-w-[260px]"
          >
            <span>Schedule Consultation</span>
            <ArrowUpRight size={16} />
          </Link>
          <Link
            to="/contact"
            data-testid="cta-contact"
            className="btn-ghost-dark px-8 py-5 text-[12px] uppercase tracking-[0.25em] font-mono inline-flex items-center justify-between gap-6 min-w-[260px]"
          >
            <span>Contact our Team</span>
            <ArrowUpRight size={16} />
          </Link>
        </div>
      </div>
    </section>
  );
}
